import urlTemplate from 'url-template';
import { useAxios } from 'src/hooks/use-axios';

export const JOB_RUN_RETRY_URL = `${PRISMA_CONFIG.transparencyReporting}/job-runs/{id}/retry`;

type HookConfig = {
  jobRunRetryUrl: string;
};

type ExecuteProps = {
  id: number;
};

export function useJobRunRetry({ jobRunRetryUrl }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { id }: ExecuteProps) => {
      const url = urlTemplate.parse(jobRunRetryUrl).expand({ id });

      return axios.request<boolean>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: false }
  );

  return request;
}

export type JobRunRetryRequest = ReturnType<typeof useJobRunRetry>;
